import { create } from "zustand";

export const useQuizModalStore = create((set) => ({
  isQuizModalOpen: false,
  step: 0,
  quizPhase: "intro",
  setQuizPhase: (phase) => set({ quizPhase: phase }),
  openQuizModal: () => set({ isQuizModalOpen: true }),
  openQuizModalWithTimeout: (timeout = 2000) => {
    setTimeout(() => set({ isQuizModalOpen: true }), timeout);
  },
  closeQuizModal: () => set({ isQuizModalOpen: false }),
  nextStep: () => set((state) => ({ step: state.step + 1 })),
  prevStep: () => set((state) => ({ step: state.step - 1 })),
  setStep: (step) => set({ step }),
  isQuizCompleted: false,
  setQuizCompleted: (completed) => set({ isQuizCompleted: completed }),
}));
